import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../client/client';
import SliderNotasCat from './SliderNotasCat';
import Slider from './Slider';
import { EsqueletoArticulo } from './Esqueleto';
import FullNews from './FullNews';

// SliderNotasCat solo muestra imagen y titulo: traer el "body" de todas las
// noticias hermanas solo para listarlas es descargar texto que nadie ve.
const LIGHT_FIELDS = 'id, number, title, written_by, category_id, image_url, created_at, updated_at, fecha_publicacion';

const News = () => {
    const { id } = useParams();
    const [categoryData, setCategoryData] = useState(null);
    const [newsData, setNewsData] = useState(null);
    const [filteredNews, setFilteredNews] = useState([]);

    useEffect(() => {
        const fetchNewsData = async () => {
            const { data, error } = await supabase
                .from('news')
                .select('*')
                .eq('id', id)
                .single();

            if (!error) {
                setNewsData(data);
                fetchCategoryData(data.category_id);
                fetchAllNews(data.category_id, data.id);
            } else {
                console.error("Error fetching news:", error);
            }
        };

        fetchNewsData();
    }, [id]);

    const fetchCategoryData = async (categoryId) => {
        const { data: categoryData, error } = await supabase
            .from('categorias')
            .select('*')
            .eq('id', categoryId);

        if (!error && categoryData.length > 0) {
            setCategoryData(categoryData[0]);
        } else {
            console.error("Error fetching category data:", error);
        }
    };

    // Relacionadas: primero las de la misma sección, y si no llegan a seis se
    // completa con lo más reciente del resto de la revista. Antes, una sección
    // con una sola nota dejaba el bloque casi vacío.
    const MINIMO_RELACIONADAS = 6;

    const fetchAllNews = async (categoryId, mainNewsId) => {
        const { data, error } = await supabase
            .from('news')
            .select(LIGHT_FIELDS)
            .eq('category_id', categoryId)
            .order('created_at', { ascending: false });

        if (error) {
            console.error('Error al cargar las notas de la sección:', error);
            return;
        }

        let relacionadas = (data || []).filter((n) => n.id !== mainNewsId);

        if (relacionadas.length < MINIMO_RELACIONADAS) {
            const { data: recientes, error: errorRecientes } = await supabase
                .from('news')
                .select(LIGHT_FIELDS)
                .neq('category_id', categoryId)
                .order('created_at', { ascending: false })
                .limit(MINIMO_RELACIONADAS);

            if (!errorRecientes && recientes) {
                const yaEstan = new Set(relacionadas.map((n) => n.id));
                for (const n of recientes) {
                    if (relacionadas.length >= MINIMO_RELACIONADAS) break;
                    if (n.id !== mainNewsId && !yaEstan.has(n.id)) relacionadas.push(n);
                }
            }
        }

        setFilteredNews(relacionadas);
    };

    const formatearFecha = (valor) => {
        if (!valor) return '';
        return new Date(valor).toLocaleDateString('es-PE', {
            day: 'numeric', month: 'long', year: 'numeric',
        });
    };

    return (
        <div className="ed-shell">
            {newsData ? (
                <div className="ed-grid" style={{ paddingTop: '1.5rem' }}>
                    <div>
                        {newsData.id && categoryData ? (
                            <FullNews
                                id={newsData.id}
                                title={newsData.title}
                                subtitle={newsData.written_by}
                                image={newsData.image_url || "https://via.placeholder.com/300"}
                                text={newsData.body}
                                color={categoryData.color}
                                categoria={categoryData}
                                fecha={newsData.fecha_publicacion || newsData.updated_at || newsData.created_at}
                                minutos={newsData.minutos_lectura}
                            />
                        ) : (
                            <p>Cargando noticia o categoría...</p>
                        )}

                        {filteredNews.length > 0 && (
                            <div className="mt-100">
                                <h1>Más de {categoryData?.name || 'la revista'}</h1>
                                <SliderNotasCat
                                    filteredNews={filteredNews}
                                    fotoCompletaCategoriaId={/legal/i.test(categoryData?.name || '') ? categoryData.id : null}
                                />
                            </div>
                        )}
                    </div>

                    <aside className="ed-aside">
                        <h2 className="ed-section-head">Lo más visto</h2>
                        <ol className="ed-ranked">
                            {filteredNews.slice(0, 5).map((n) => (
                                <li key={n.id}>
                                    <Link to={`/noticias/${n.id}`}>
                                        <h3 className="ed-list__title">{n.title}</h3>
                                        <p className="ed-list__date">
                                            {formatearFecha(n.updated_at || n.created_at)}
                                        </p>
                                    </Link>
                                </li>
                            ))}
                        </ol>
                    </aside>
                </div>
            ) : (
                <div className="ed-grid" style={{ paddingTop: '1.5rem' }}>
                    <EsqueletoArticulo />
                </div>
            )}

            {newsData && (
                <section className="ed-revistas-pie">
                    <h2 className="ed-section-head">Ediciones de Cámara AQP</h2>
                    <Slider />
                </section>
            )}
        </div>
    );
};

export default News;
